import { Injectable, signal } from '@angular/core';
import { RenderPayload } from '../models/render-payload';

const CACHE_KEY_PREFIX = 'edge_display_payload_';

@Injectable({ providedIn: 'root' })
export class DisplayCacheService {
    private readonly fallbackState = signal<RenderPayload | null>(null);

    store(displayId: string, payload: RenderPayload): void {
        try {
            localStorage.setItem(CACHE_KEY_PREFIX + displayId, JSON.stringify(payload));
        } catch {
            // localStorage may be unavailable in restrictive kiosk environments — fail silently
        }
        this.fallbackState.set(payload);
    }

    restore(displayId: string): RenderPayload | null {
        try {
            const raw = localStorage.getItem(CACHE_KEY_PREFIX + displayId);
            if (raw) {
                const payload = JSON.parse(raw) as RenderPayload;
                this.fallbackState.set(payload);
                return payload;
            }
        } catch {
            // corrupted entry — ignore
        }
        return null;
    }

    clear(displayId: string): void {
        try {
            localStorage.removeItem(CACHE_KEY_PREFIX + displayId);
        } catch {
            // ignore
        }
        this.fallbackState.set(null);
    }

    getFallback(): RenderPayload | null {
        return this.fallbackState();
    }
}
